import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApplicationService } from '@app/shared/application/application.service';
import { SlapService } from './slap.service';
import { AppComponentBase } from '@shared/common/app-component-base';

@Injectable()
export class SlapGuard implements CanActivate, CanDeactivate<AppComponentBase> {

    constructor(
        private slapService: SlapService,
        private applicationService: ApplicationService,
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
       return this.slapService.getSlap(this.applicationService.caseId).pipe(map(() => true));
    }

    canDeactivate(component: AppComponentBase): boolean | Observable<boolean> {
        this.slapService.closeSlap();
        return true;
    }
}
